module.exports = __webpack_public_path__ + "static/img/logo.285704e.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/logo.png
// module id = 244
// module chunks = 0